<app-bread-crumb
    [items]="[{text:  'produtos',link:'/admin/products'},{text:  'stock',link:'/admin/stock/list'},{text:pageTitle}]"
    [sectionTitle]="pageTitle">
</app-bread-crumb>


<section class="content">

    <!-- inicio do formulario -->
    <form [formGroup]="objectForm" novalidate (ngSubmit)="submitForm()">

        <ng-box [boxIcon]="'fa fa-briefcase'" [boxTitle]="'Dados do Stock'" [showBoxFooter]="true">

            <!-- inicio do cabesalho -->
            <ng-container class="ng-box-header">
                <ng-button (click)="back()" [button]="{name:'back',faIconClass:'fa fa-arrow-left',color:'secondary'}">
                </ng-button>
            </ng-container>
            <!-- fim do cabesalho -->

            <!-- inicio do conteudo -->
            <ng-container class="ng-box-content">

                <div class="row">

                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Produto(*)" errorMessage="Campo obrigatório">

                                <select formControlName="product_id" class="form-control">
                                    <option *ngFor="let product of products" [value]="product.id">{{ product.title }}
                                    </option>
                                </select>
                            </app-input>

                        </div>

                    </div>


                    <div class="col-md-6">
                        <div class="form-group">

                            <app-input label="Cor(*)" errorMessage="Campo obrigatório">
                                <select id="color" formControlName="color_id" class="form-control">
                                    <option *ngFor="let color of colors" [value]="color.id">{{color.description}}
                                    </option>
                                </select>
                            </app-input>

                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">

                            <app-input label="Tamanho(*)" errorMessage="Campo obrigatório">
                                <select id="size" formControlName="size_id" class="form-control">
                                    <option *ngFor="let size of sizes" [value]="size.id">
                                        {{size.size+'-'+size.description}}</option>
                                </select>
                            </app-input>

                        </div>
                    </div>

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Promoção(*)" errorMessage="Campo obrigatório">

                                <select formControlName="flash" class="form-control">

                                    <option value="">Escolha Promoção</option>
                                    <option value="0">Não Promocionar</option>
                                    <option value="1">Promocionar</option>
               
                                </select>
                            </app-input>

                        </div>

                    </div>

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Visibilidade do Produto na App(*)" errorMessage="Campo obrigatório">

                                <select formControlName="visible" class="form-control">
                                    <option value="MNAK">Mostrar na App Khuzela</option>
                                    <option value="NMNAK">Não Mostrar na App Khuzela</option>
                                </select>
                            </app-input>

                        </div>

                    </div>

                </div>

                <div class="row">

                    <div class="col-md-4">
                        <div class="form-group">

                            <app-input label="Stock Máximo(*)" errorMessage="Campo obrigatório">
                                <input type="text" formControlName="quant_total" class="form-control">
                            </app-input>

                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group">

                            <app-input label="Stock Minímo(*)" errorMessage="Campo obrigatório">
                                <input type="text" formControlName="quant_min" class="form-control">
                            </app-input>

                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group">
                            <app-input label="Preço(*)"
                                errorMessage="- Campo obrigatório; - Somente números são aceites;">
                                <input type="text" formControlName="price" class="form-control">
                            </app-input>
                        </div>
                    </div>

                </div>

            </ng-container>

            <ng-container class="ng-box-footer">
                <div class="row">
                    <div class="col-xs-12">

                        <ng-button *ngIf="isAdminOrManager() && currentAction=='new'" class="pull-right" [button]="{
                                name:'salvar',
                                color:'danger',
                                faIconClass:'fa fa-save',
                                type:'submit',
                                loadingText:'SALVANDO',
                                isLoading:isButtonLoading,
                                isDisabled:isButtonLoading || objectForm.invalid}">
                        </ng-button>
                        <ng-button *ngIf="isAll() && currentAction=='edit'" class="pull-right" [button]="{
                                name:'salvar',
                                color:'danger',
                                faIconClass:'fa fa-save',
                                type:'submit',
                                loadingText:'SALVANDO',
                                isLoading:isButtonLoading,
                                isDisabled:isButtonLoading || objectForm.invalid}">
                        </ng-button>

                    </div>
                </div>
            </ng-container>

        </ng-box>
        <!-- fim do box -->

    </form>

    <!-- fim do formulario -->
</section>